
import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout';
import { db } from '../../firebaseconf';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { Alert } from '@mui/material';
import Preloader from '../../components/preloader';
import Header from '../../components/header';
import { COLLEGE_SEMESTERS } from '../../utils/semesterDefaults';

export default function CheckFinalMarks() {
    const [semesters, setSemesters] = useState([]);
    const [selectedSemester, setSelectedSemester] = useState('');
    const [student, setStudent] = useState(null);
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setLoading(true);
                const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
                if (!loggedUser || !loggedUser.institution_id) return;
                
                // Set student data from logged user
                setStudent(loggedUser);
                
                // Fetch semesters from subjects
                const subjectsRef = collection(db, 'institutions', loggedUser.institution_id, 'subjects');
                const subjectsSnapshot = await getDocs(subjectsRef);
                
                if (subjectsSnapshot.empty) {
                    // Use hardcoded semesters if no subjects found
                    setSemesters(COLLEGE_SEMESTERS);
                } else {
                    const uniqueSemesters = [...new Set(subjectsSnapshot.docs.map(doc => doc.data().semester))];
                    setSemesters(uniqueSemesters.length > 0 ? uniqueSemesters : COLLEGE_SEMESTERS);
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchInitialData();
    }, []);

    useEffect(() => {
        if (selectedSemester) {
            const fetchSubjects = async () => {
                try {
                    const loggedUser = JSON.parse(sessionStorage.getItem("logged_user"));
                    if (!loggedUser || !loggedUser.institution_id) return;
                    
                    const q = query(
                        collection(db, 'institutions', loggedUser.institution_id, 'subjects'),
                        where('semester', '==', selectedSemester)
                    );
                    const snapshot = await getDocs(q);
                    const subjectsData = snapshot.docs.map(doc => doc.data().name || doc.data().subject_name);
                    setSubjects(subjectsData);
                } catch (error) {
                    console.error('Error fetching subjects:', error);
                }
            };
            fetchSubjects();
        }
    }, [selectedSemester]);

    return (
        <Layout>
            <Header title="Check Final Marks" />
            <section className="col-12 pt-5">
                <div className="row justify-content-center">
                    {loading && <Preloader />}
                    <div className="form-group form-floating col-5 ms-3">
                        <select
                            required
                            className="form-select"
                            value={selectedSemester}
                            onChange={(e) => setSelectedSemester(e.target.value)}
                        >
                            <option value="">Select Semester</option>
                            {semesters.map((semester) => (
                                <option key={semester} value={semester}>{semester}</option>
                            ))}
                        </select>
                        <label>Select Semester:</label>
                    </div>

                    {selectedSemester && student && (
                        <div className="col-10 mt-4">
                    {semesters.length === 0 && (
                        <Alert severity="info" sx={{ mb: 2 }}>
                            📚 No subjects found. Please upload dummy data or add subjects in the admin panel.
                        </Alert>
                    )}
                            <table className="table table-hover table-responsive">
                                <thead className="table-light">
                                    <tr>
                                        <th>Name</th>
                                        <th>Roll No</th>
                                        {subjects.map((sub) => (
                                            <th key={sub}>{sub}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{student.name}</td>
                                        <td>{student.roll_number}</td>
                                        {subjects.map((sub) => (
                                            <td key={sub}>
                                                {student?.FinalMarks?.[selectedSemester]?.[sub] || 'N/A'}
                                            </td>
                                        ))}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </section>
        </Layout>
    );
}
